import { useCheckPermission } from "@/domain/_shared/permission/hooks/api/use-check-permission";
import { useCurrentUserContext } from "@/domain/user/hooks/use-current-user-context";

export const useCanManageWorkspace = ({ workspaceId }: { workspaceId: string }) => {
  const { isSuperUser } = useCurrentUserContext();
  const { hasPermission, loading } = useCheckPermission({
    resource: "workspace",
    action: "manage",
    resourceId: workspaceId,
    enabled: !isSuperUser,
  });

  if (isSuperUser) {
    return { canManageWorkspace: true, loading: false };
  }

  return { canManageWorkspace: hasPermission, loading };
};
